"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIndexString = exports.getTrueKeys = void 0;
function getTrueKeys(obj) {
    const ret = [];
    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key) &&
            obj[key] === true) {
            ret.push(key);
        }
    }
    return ret;
}
exports.getTrueKeys = getTrueKeys;
function getIndexString(keys) {
    return keys.join('&');
}
exports.getIndexString = getIndexString;
